/** Single source of truth for URLs — import these instead of hardcoding strings. */
export const paths = {
  home: '/',
  category: (id = 'all') => `/c/${id}`,
  wishlist: '/c/all?saved=1',
  product: (id) => `/p/${id}`,
  /** Checkout settles one currency at a time — see useCartItems. */
  checkout: (currency) => (currency ? `/checkout?cur=${encodeURIComponent(currency)}` : '/checkout'),
  orders: '/orders',
  /**
   * Renewing one book the reader already owns: checkout, for that one line.
   * `languages` are any the reader ADDS for the new term ("renew with Marathi").
   */
  renew: (bookId, languages = []) =>
    `/checkout?renew=${encodeURIComponent(bookId)}${langsParam(languages)}`,
  /** Adding languages to a book the reader already owns, for the rest of its term. */
  addLanguage: (bookId, languages = []) =>
    `/checkout?addlang=${encodeURIComponent(bookId)}${langsParam(languages)}`,
  confirmation: '/order/confirmed',
  /** Where playTUB's signed-in handoff lands; it carries the ticket in the fragment. */
  sso: '/sso',
};

function langsParam(languages) {
  return languages.length > 0 ? `&langs=${encodeURIComponent(languages.join(','))}` : '';
}
